export default __webpack_public_path__ + "static/media/delete.e9508b6f.svg";